














































import Vue from 'vue'
import { mapState } from 'vuex'

import { Find as FindDevice } from '@/api/device'
import { Device } from '@/types/device'

export default Vue.extend({
  name: 'CEMSDeviceSetting',
  data: () => {
    return {
      devices: [] as Device[],
    }
  },
  computed: {
    ...mapState('license', { license: 'detailLicense' }),
  },
  methods: {
    async findDevices() {
      this.devices = await FindDevice()
    },
    newDevice() {
      this.$router.push('/cems/setting/device/new-device')
    },
    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------

    onRowClick(device: Device) {
      this.$router.push(`/cems/setting/device/${device.id}/configuration`)
    },
  },
  created() {
    this.findDevices()
  },
})
